<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('timebags')"
      :columns="columns"
      :column_search="true"
      resource_url="/timebag/bag/datatables"
      mode="table"
      :page_length="50"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto">
              <img
                src="https://cdn-icons-png.flaticon.com/512/4071/4071336.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content has-text-centered">
                <progress
                  class="progress"
                  :class="{
                    'is-danger': item.spent_hours > item.number_of_hours * 0.8,
                    'is-warning':
                      item.spent_hours <= item.number_of_hours * 0.8 &&
                      item.spent_hours > item.number_of_hours * 0.6,
                    'is-success':
                      item.spent_hours <= item.number_of_hours * 0.6,
                  }"
                  :value="item.spent_hours"
                  :max="item.number_of_hours"
                ></progress>
                <div class="title is-5">
                  {{ item.name }}
                  <span class="tag">
                    {{ item.spent_hours }} {{ $t("out of") }}
                    {{ item.number_of_hours }}
                    {{ $t("hours") }}
                  </span>
                </div>
                <div class="subtitle is-5">{{ item.customer }}</div>
                <!-- <pre>{{ item }}</pre> -->
              </div>
            </div>
          </div>
          <footer class="card-footer" v-show="true">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </a>
            <a
              class="card-footer-item button"
              :data-tooltip="$t('add service')"
              @click="add_service(item)"
            >
              <span class="icon"><i class="fa fa-plus"></i></span>
            </a>
            <a
              class="card-footer-item button"
              :data-tooltip="$t('service list')"
              @click="service_list(item)"
            >
              <span class="icon"><i class="fa fa-list"></i></span>
            </a>
            <a
              class="card-footer-item button"
              :data-tooltip="$t('share')"
              @click="share(item)"
            >
              <span class="icon"><i class="fa fa-share"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
          </footer>
        </div>
      </template>
    </generic-table>
  </div>

  <timebag-modal ref="timebag_modal" @success="refresh" />
  <service-modal ref="service_modal" @success="refresh" />
  <service-list-modal ref="service_list_modal" @edit_service="edit_service" />
  <share-modal ref="share_modal" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  put,
  error_message,
  format_date,
  format_currency,
} from "@/utils";
import TimebagModal from "./timebag_modal/Index.vue";
import ServiceModal from "./service_modal/Index.vue";
import ServiceListModal from "./service_list_modal/Index.vue";
import ShareModal from "./share_modal/Index.vue";

export default {
  name: "TimebagDatatable",
  components: {
    GenericTable,
    TimebagModal,
    ServiceModal,
    ServiceListModal,
    ShareModal,
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("timebag"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="has-text-weight-bold">${row.name}</div>
                    <div class="subtitle is-6">${row.customer}</div>`;
          },
        },
        // {
        //   title: v.$t("status"),
        //   searchable: false,
        //   data: (row) => {
        //     return `<span class="tag is-success">${row.spent_hours} / ${
        //       row.number_of_hours
        //     } ${v.$t("hours")}</span>`;
        //   },
        // },
        {
          title: v.$t("status"),
          searchable: false,
          data: (row) => {
            let className = "";
            if (row.spent_hours > row.number_of_hours * 0.8) {
              className = "is-danger";
            } else if (
              row.spent_hours <= row.number_of_hours * 0.8 &&
              row.spent_hours > row.number_of_hours * 0.6
            ) {
              className = "is-warning";
            } else {
              className = "is-success";
            }
            return `<div class="media"><div class="media-content has-text-centered">
                      <progress
                        class="progress ${className}"
                        value="${row.spent_hours}"
                        max="${row.number_of_hours}"
                      ></progress>
                      <div class="title is-5">
                        <span class="tag">
                          ${row.spent_hours} ${v.$t("out of")}
                          ${row.number_of_hours}
                          ${v.$t("hours")}
                        </span>
                      </div>
                    </div>
                  </div>`;
          },
        },
        {
          title: v.$t("summary"),
          searchable: false,
          data: (row) => {
            let payment_icon = "";
            if (row.payment_status === "paid") {
              payment_icon = `<span class="icon has-text-success"><i class="fa fa-check"></i></span>`;
            } else if (row.payment_status === "billed") {
              payment_icon = `<span class="icon has-text-info"><i class="fa fa-money"></i></span>`;
            } else if (row.payment_status === "in-progress") {
              payment_icon = `<span class="icon has-text-warning"><i class="fa fa-spinner fa-spin"></i></span>`;
            } else {
              payment_icon = `<span class="icon has-text-danger"><i class="fa fa-times"></i></span>`;
            }

            let timbg = `<div class="title is-5">${
              row.timebag_services.length
            } ${v.$t("tasks")} </div>
                    <div class="subtitle is-6 mb-0">
                      ${row.timebag_services.reduce(
                        (acc, service) => acc + Number(service.number_of_hours),
                        0
                      )} ${v.$t("hours")}
                    </div>
                    <div class="subtitle is-6">
                      ${Number(
                        row.spent_hours *
                          (row.settings ? row.settings.price_per_hour : 0)
                      ).toLocaleString(undefined, {
                        style: "currency",
                        currency: "USD",
                      })}
                    </div>`;
            return `<div class="media">
                      <div class="media-content">
                        <div class="columns is-mobile">
                          <div class="column is-narrow">
                            ${timbg}
                          </div>
                          <div class="column is-narrow">
                            ${payment_icon} ${v.$t(
              row.payment_status || "unknown"
            )}
                          </div>                          
                        </div>
                      </div>
                    </div>`;
          },
        },
        // {
        //   title: v.$t("service list"),
        //   searchable: false,
        //   data: (row) => {
        //     return `<table class="table is-fullwidth is-striped is-hoverable">
        //               <tbody>
        //                 ${row.timebag_services
        //                   .map(
        //                     (service) => `
        //                     <tr>
        //                       <td>${format_date(service.date)}</td>
        //                       <td>${service.description || ""}</td>
        //                       <td>${service.number_of_hours}</td>
        //                     </tr>`
        //                   )
        //                   .join("")}
        //               </tbody>
        //             </table>`;
        //   },
        // },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.number || "";
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("add service"),
                icon: "fa fa-plus",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.add_service(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.edit(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("share"),
                icon: "fa fa-share",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.share(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("service list"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.service_list(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete timebag?"),
                    v,
                    () => {
                      del("/timebag/bag", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.timebag_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit(item) {
      let v = this;
      v.$refs.timebag_modal.edit_modal(item.uuid);
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete timebag?"),
        v,
        () => {
          del("/timebag/bag", { uuid: item.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    add_service(item) {
      let v = this;
      v.$refs.service_modal.show_modal(item);
    },
    service_list(item) {
      let v = this;
      v.$refs.service_list_modal.show_modal(item);
    },
    edit_service(uuid) {
      let v = this;
      v.$refs.service_modal.edit_modal(uuid);
    },
    share(item) {
      let v = this;
      v.$refs.share_modal.show_modal(item);
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
